import Loadable from 'react-loadable';

const Loading = props => {
  const { error } = props;
  if (error) {
    window.location.reload();
  }
  return null;
};

// Error Page
export const ErrorPage = Loadable({
  loader: () => import('../components/ErrorPage'),
  loading: Loading,
});

// Dashboard Page
export const DashboardPage = Loadable({
  loader: () => import('../components/Dashboard/templates/DashboardContainer'),
  loading: Loading,
});

// Invite User Page
export const InviteUserPage = Loadable({
  loader: () => import('../components/InviteUser/templates/InviteUserContainer'),
  loading: Loading,
});

// User Detail Page
export const UserDetailPage = Loadable({
  loader: () => import('../components/UserDetail/templates/UserDetailContainer'),
  loading: Loading,
});

// User list Page
export const UserListPage = Loadable({
  loader: () => import('../components/UserList/templates/UserListContainer'),
  loading: Loading,
});

// White label Page
export const WhiteLabelPage = Loadable({
  loader: () => import('../components/WhiteLabel/templates/WhiteLabelContainer'),
  loading: Loading,
});

// Permission Page
export const PermissionPage = Loadable({
  loader: () => import('../components/Permission/template/Permission/PermissionContainer'),
  loading: Loading,
});

// Message Page
export const MessagePage = Loadable({
  loader: () => import('../components/Message/template/Message/MessageContainer'),
  loading: Loading,
});

// Team list Page
export const TeamListPage = Loadable({
  loader: () => import('../components/TeamList/templates/TeamListContainer'),
  loading: Loading,
});

export const BulkUploadPage = Loadable({
  loader: () => import('../components/BulkUpload/templates/BulkUpload'),
  loading: Loading,
});

export const UserAnalyticsPage = Loadable({
  loader: () => import('../components/UserAnalytics/templates/UserAnalyticsContainer'),
  loading: Loading,
});

export const DataExportPage = Loadable({
  loader: () => import('../components/DataExport/templates/DataExport'),
  loading: Loading,
});

export const MaintenanceModePage = Loadable({
  loader: () => import('../components/MaintenanceMode/templates/MaintenanceMode'),
  loading: Loading,
});

// Loading Page
export const LoadingPage = Loadable({
  loader: () => import('../components/LoadingPage/templates/LoadingPageContainer'),
  loading: Loading,
});
